import { objectId } from "@shared/util/object-id"

export const patchOpNames = ["set", "unset", "inc", "push", "pull", "pullAll", "addToSet"] as const

export type PatchOpName = (typeof patchOpNames)[number]
export type PatchPath = string
export type EmbeddedPatchPath = PatchPath
export type PatchOp = [path: PatchPath, value: unknown]
export type PatchOps = Partial<Record<PatchOpName, PatchOp[]>>
export type CompletePatchOps = Record<PatchOpName, PatchOp[]>
export type PatchableRecord = Record<string, unknown>

export interface PatchableDocument extends PatchableRecord {
  internalVersion?: number
}

export interface PatchModel {
  id: string | null
  document: PatchDocument
  embeddedDocument: PatchEmbeddedDocument | null
  actionId?: string | null
  timeAtCreation?: string | null
  revisionAtCreation?: string | number | null
  isCreatePatch?: boolean
}

export interface PatchDocument {
  id: string
  modelType: string
  ops: PatchOps
}

export interface PatchEmbeddedDocument {
  path: EmbeddedPatchPath
  elemMatch: PatchableRecord
  ops: PatchOps
}

export type OpsDoc = PatchOps

export function createEmptyPatchOps(): CompletePatchOps {
  return {
    set: [],
    unset: [],
    inc: [],
    push: [],
    pull: [],
    pullAll: [],
    addToSet: [],
  }
}

export function createBaseDocument(modelType: string, id: string): PatchDocument {
  return {
    id,
    modelType,
    ops: createEmptyPatchOps(),
  }
}

export function createEmbeddedDocument(
  path: EmbeddedPatchPath,
  elemMatch: PatchableRecord,
): PatchEmbeddedDocument {
  return {
    path,
    elemMatch,
    ops: createEmptyPatchOps(),
  }
}

export function createPatch(
  modelType: string,
  id: string,
  embeddedPath?: EmbeddedPatchPath,
  embeddedElemMatch: PatchableRecord = {},
): PatchModel {
  return {
    id: objectId(),
    document: createBaseDocument(modelType, id),
    embeddedDocument:
      embeddedPath === undefined ? null : createEmbeddedDocument(embeddedPath, embeddedElemMatch),
    actionId: null,
    timeAtCreation: null,
    revisionAtCreation: null,
    isCreatePatch: false,
  }
}
